// @ts-nocheck
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import SvgIconStyle from '../../components/SvgIconStyle';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import LocationOnIcon from '@mui/icons-material/LocationOn';
// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);
const getIcon2 = (name) => (
  <AttachMoneyIcon  sx={{ width: '100%', height: '100%' }} />
);
const getIcon3 = (name) => (
  <LocationOnIcon  sx={{ width: '100%', height: '100%' }} />
);


const ICONS = {
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  user2: getIcon2('ic_user2'),
  jobsite: getIcon3(''),
  dashboard: getIcon('ic_dashboard')
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'Admin',
    items: [
      {
        title: 'company pulse',
        path: PATH_DASHBOARD.general.analytics,
        icon: ICONS.dashboard
      },
      { title: 'users', path: PATH_DASHBOARD.user.root, icon: ICONS.user,
        children: [
          { title: 'Builders', path: PATH_DASHBOARD.user.profile },
          { title: 'Subcontractors', path: PATH_DASHBOARD.user.cards },
          { title: 'Workers', path: PATH_DASHBOARD.user.list }
        ]
      },
      { title: 'subscriptions', path: PATH_DASHBOARD.user.root, icon: ICONS.user2,
        children: [
          { title: 'Builders', path: PATH_DASHBOARD.user.profile },
          { title: 'Subcontractors', path: PATH_DASHBOARD.user.cards },
          { title: 'Workers', path: PATH_DASHBOARD.user.list }
        ]
      },
      { title: 'Job Sites', path: PATH_DASHBOARD.user.jobsites, icon: ICONS.jobsite },
      { title: 'Message Templates', path: PATH_DASHBOARD.admin.templates, icon: ICONS.mail },

    ]
  },


  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'management',
    items: [
      // MANAGEMENT : USER
      {
        title: 'user',
        path: PATH_DASHBOARD.user.root,
        icon: ICONS.user,
        children: [
          { title: 'profile', path: PATH_DASHBOARD.user.profile },
          { title: 'cards', path: PATH_DASHBOARD.user.cards },
          { title: 'list', path: PATH_DASHBOARD.user.list },
          { title: 'create', path: PATH_DASHBOARD.user.newUser },
          { title: 'edit', path: PATH_DASHBOARD.user.editById },
          { title: 'account', path: PATH_DASHBOARD.user.account }
        ]
      }
    ]
  }
];


export default sidebarConfig;